<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-after: always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_toc_1"><span>Acknowledgments</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent"><span style=" font-weight: bold; font-size: 1.00em; text-transform: uppercase;">WRITING</span> is a solitary endeavor, but it still requires a support system, and I’m so lucky to have an ever-expanding one. My original cheering section, my husband and kids, are so patient with my spacey stares as a pesky plot point suddenly works itself out during conversations and my lies about starting dinner “as soon as I finish this paragraph.”</p>
<p class="P_Normal">I don’t know how I’d function without the wonderful MM community on Facebook, who provide a safe space and unending amusement. I’ve made a lot of fabulous friends over the years, but this book wouldn’t have happened without two of them, Hunter Frost and Caraway Carter. They are always there when I need them, and they unerringly know when to give me a shoulder to lean on and when to give me a kick in the ass. This book required many kicks, but I’m so glad they did because Nick and Drew were totally worth it.</p>
<p class="P_Normal">And lastly, a huge, huge thank-you to everyone who buys my books. You keep me going and your confidence in me means the world. Thank you.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?78481fc7